import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import { useHistory } from 'react-router-dom'
import _get from 'lodash.get'

import { timezones, currencies, staff, lang } from 'utils/helpers'
import { SelectCountry } from '../../Chat/Plugins/commons'
import { userIsAuthorized } from '../../../routes/Authorizer/helpers'
import CompanyValidator from '../../Management/Companies/CompanyValidator'
import ButtonDeleteCompany from '../../Management/Companies/ButtonDeleteCompany'
import SidePopup from '../../SidePopup'

import dkvConfiguration from 'constants/dkv.constants'
import { updateCompany } from '../../../redux/actions/companies'

import './styles.scss'
import { SelectWithLabel } from 'components/Form'

const CompanyEdit = (props) => {
  const optionsTimezones = timezones()
  const optionsCurrencies = currencies()
  const optionsStaff = staff()
  const history = useHistory()
  const companies = useSelector(state => state.companies)
  const operator = useSelector(state => state.user)
  const [timezone, setTimezone] = React.useState(companies.timezone)
  const [currency, setCurrency] = React.useState(companies.currency)
  const [currentStaff, setCurrentStaff] = React.useState(companies.staff)
  const dispatch = useDispatch()

  const hideModal = (e) => {
    if (e) e.preventDefault()
    history.push(`/dashboard/management/company/${companies._id}`)
  }

  const handleSubmit = (values, { setSubmitting, setErrors }) => {
    dispatch(updateCompany({ ...values, timezone, currency, staff: currentStaff }))
      .then(() => hideModal())
      .catch((data) => {
        const errorsFields = _get(data, 'error.fields', [])

        if (errorsFields.length > 0) {
          setErrors(
            errorsFields.reduce((preV, current) => {
              preV[current] = I18n.t(data.type)

              return preV
            }, {})
          )
        }
      })
      .finally(() => setSubmitting(false))
  }

  const validatePhoneNumber = (value) => {
    const regex = /^\+\d{1,}$/
    if (value && !regex.test(value)) {
      return I18n.t('dasboard_format-phone-number-incorrect')
    }
  }

  return (
    <SidePopup onHide={hideModal} className={'company'} backButton>
      <div className='company-edit-container'>
        <Formik initialValues={{ ...companies }} validate={CompanyValidator} onSubmit={handleSubmit}>
          {({ isSubmitting, handleSubmit, setFieldValue, values, errors }) => (
            <Form>
              <div className='title-container'>
                <div className='title'>{companies.name || ''}</div>
                <div className='subtitle-section'></div>
              </div>
              <div className='contact-info-container'>
                <div className='contact-row'>
                  <div style={{ marginRight: '25px' }}>
                    <SelectWithLabel
                      name='currency'
                      id='company.currency'
                      label={I18n.t('dashboard_currency')}
                      value={currency ? { value: currency || ' ', label: (optionsCurrencies.find(it=> it.value === currency) || {}).label || '' } : null}
                      onChange={(value)=> setCurrency(value.value)}
                      options={optionsCurrencies}
                      classNameWrapper='currency-selector'
                    />
                    <ErrorMessage name='currency' component='small' className='text-danger' />
                  </div>
                  <div>
                    <SelectWithLabel
                      name='staff'
                      id='company.staff'
                      label={I18n.t('dashboard_employees')}
                      value={currentStaff ? { value: currentStaff || ' ', label: (optionsStaff.find(it=> it.value === currentStaff) || {}).label || '' } : null}
                      onChange={(value)=> setCurrentStaff(value.value)}
                      options={optionsStaff}
                      classNameWrapper='currency-selector'
                    />
                    <ErrorMessage name='staff' component='small' className='text-danger' />
                  </div>
                </div>
                <div className='contact-row'>
                  <SelectWithLabel
                    name='company.timezone'
                    id='company.timezone'
                    label={lang('dashboard_time-zone')}
                    value={timezone ? { value: timezone || ' ', label: (optionsTimezones.find(it=> it.value === timezone) || {}).label || '' } : null}
                    onChange={(value)=> setTimezone(value.value)}
                    options={optionsTimezones}
                    classNameWrapper='timezone-selector'
                  />
                  <ErrorMessage name='timezone' component='small' className='text-danger' />
                </div>
                <div className='title'>{I18n.t('dashboard_contact-information')}</div>
                <div className='contact-row'>
                  <div className='contact-item' style={{ marginRight: '30px' }}>
                    <div className='label'>{I18n.t('dashboard_primary-phone')}<div style={{ color: 'red', marginLeft: '2px' }}>*</div></div>
                    <Field id='company.primaryPhone' type='text' name='primaryPhone' className='form-control' required validate={validatePhoneNumber} />
                    <ErrorMessage name='primaryPhone' component='small' className='text-danger' />
                  </div>
                  <div className='contact-item'>
                    <div className='label'>{I18n.t('dashboard_secondary-phone')}</div>
                    <Field id='company.secondaryPhone' type='text' name='secondaryPhone' className='form-control' required validate={validatePhoneNumber} />
                    <ErrorMessage name='secondaryPhone' component='small' className='text-danger' />
                  </div>
                </div>
                <div className='contact-row'>
                  <div className='contact-item' style={{ width: '100%' }}>
                    <div className='label'>{I18n.t('dashboard_billing-email')}<div style={{ color: 'red', marginLeft: '2px' }}>*</div></div>
                    <Field id='company.billingEmail' type='email' name='billingEmail' className='form-control' required />
                    <ErrorMessage name='billingEmail' component='small' className='text-danger' />
                  </div>
                </div>
                <div className='contact-row'>
                  <div className='contact-item' style={{ width: '100%' }}>
                    <div className='label'>{I18n.t('dashboard_business-email')}</div>
                    <Field id='company.businessEmail' type='email' name='businessEmail' className='form-control' />
                    <ErrorMessage name='businessEmail' component='small' className='text-danger' />
                  </div>
                </div>
                <div className='contact-row'>
                  <div className='contact-item' style={{ width: '100%' }}>
                    <div className='label'>{I18n.t('dashboard_developer-email')}</div>
                    <Field id='company.developerEmail' type='email' name='developerEmail' className='form-control' />
                    <ErrorMessage name='developerEmail' component='small' className='text-danger' />
                  </div>
                </div>
                {
                  dkvConfiguration.isDKV ? (
                    <div className='contact-row'>
                      <div className='contact-item' style={{ width: '100%' }}>
                        <div className='label'>{I18n.t('organization_nauta_email_for_error')}</div>
                        <Field id='company.externalAPIErrorEmail' type='email' name='externalAPIErrorEmail' className='form-control' />
                        <ErrorMessage name='externalAPIErrorEmail' component='small' className='text-danger' />
                      </div>
                    </div>
                  ) : null
                }
                <div className='title'>{I18n.t('dashboard_billing-information')}</div>
                <div className='contact-row'>
                  <div className='contact-item' style={{ width: '100%' }}>
                    <div className='label'>{I18n.t('dashboard_business-name')}<div style={{ color: 'red', marginLeft: '2px' }}>*</div></div>
                    <Field id='company.legalName' type='text' name='legalName' className='form-control' required />
                    <ErrorMessage name='legalName' component='small' className='text-danger' />
                  </div>
                </div>
                <div className='contact-row'>
                  <div className='contact-item' style={{ width: '100%' }}>
                    <div className='label'>NIF<div style={{ color: 'red', marginLeft: '2px' }}>*</div></div>
                    <Field id='company.nif' type='text' name='nif' className='form-control' required />
                    <ErrorMessage name='nif' component='small' className='text-danger' />
                  </div>
                </div>
                <div className='contact-row'>
                  <div className='contact-item' style={{ width: '100%' }}>
                    <div className='label'>{I18n.t('dashboard_address')}<div style={{ color: 'red', marginLeft: '2px' }}>*</div></div>
                    <Field id='company.address' type='text' name='address' className='form-control' required />
                    <ErrorMessage name='address' component='small' className='text-danger' />
                  </div>
                </div>
                <div className='contact-row'>
                  <div className='contact-item' style={{ marginRight: '30px' }}>
                    <div className='label'>{I18n.t('dashboard_postal-code')}<div style={{ color: 'red', marginLeft: '2px' }}>*</div></div>
                    <Field id='company.postalCode' type='text' name='postalCode' className='form-control' required />
                    <ErrorMessage name='postalCode' component='small' className='text-danger' />
                  </div>
                  <div className='contact-item' style={{ width: '100%' }}>
                    <div className='label'>{I18n.t('dashboard_city')}<div style={{ color: 'red', marginLeft: '2px' }}>*</div></div>
                    <Field id='company.city' type='text' name='city' className='form-control' required />
                    <ErrorMessage name='city' component='small' className='text-danger' />
                  </div>
                </div>
                <div className='contact-row'>
                  <div className='contact-item' style={{ width: '100%' }}>
                    <div className='label'>{I18n.t('dashboard_province')}<div style={{ color: 'red', marginLeft: '2px' }}>*</div></div>
                    <Field id='company.province' type='text' name='province' className='form-control' required />
                    <ErrorMessage name='province' component='small' className='text-danger' />
                  </div>
                  <div className='contact-item' style={{ marginLeft: '30px' }}>
                    <div className='label'>{I18n.t('dashboard_country')}<div style={{ color: 'red', marginLeft: '2px' }}>*</div></div>
                    <SelectCountry
                      classnameForm='mb-0'
                      id='company.country'
                      name='country'
                      value={values.country || ''}
                      onChange={({ target: { value } }) => {
                        setFieldValue('country', value)
                      }}
                      error={!!errors.country}
                      required
                    />
                  </div>
                </div>
                {
                  ['owner', 'admin'].includes(operator.role) && (
                    <div className='contact-row'>
                      <div className='contact-item' style={{ width: '100%' }}>
                        <div className='label'>{I18n.t('dashboard_order-number')}</div>
                        <Field
                          id='company.billOrderNumber'
                          className='form-control text-uppercase'
                          type='text'
                          name='billOrderNumber'
                        />
                        <ErrorMessage name='billOrderNumber' component='small' className='text-danger' />
                      </div>
                    </div>
                  )
                }
                <div className='buttons-container'>
                  {userIsAuthorized({
                    capability: props.capabilities.companies,
                    action: 'UPDATE',
                  }) && (
                    <>
                      <div className='save-button' onClick={handleSubmit}>
                        {I18n.t('dashboard_save')}
                      </div>
                      {operator.role === 'owner' && (
                        <ButtonDeleteCompany isDisabled={isSubmitting} />
                      )}
                    </>
                  )}
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </SidePopup>
  )
}

export default CompanyEdit